/**
 * Created by mukund on 1/5/18.
 *
 * AngularJS directive for empty PnP collection
 */

angular.module('mediacloudApp')
    .directive('emptyCollection', [function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/empty-collection/empty-collection.html',
            scope: {
                parent: '='
            },
            link: function(scope, element, attrs){
                scope.unpublished = scope.$parent.$parent.unpublished;
            }
        }

    }]);
